import { setNestedObjectValues, useFormikContext } from 'formik';
import React, { useEffect } from 'react';

const ValidationHack: React.FC = () => {
  const formik = useFormikContext();
  useEffect(() => {
    formik.validateForm().then((errors) => {
      formik.setTouched(setNestedObjectValues(errors, true));
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default ValidationHack;
